import './Accordion.css'
import { Link, Image } from './StyledComponents';
export function Accordion({ name, content }) {
  function onClick(evt) {
    evt.target.classList.toggle("active");
    var panel = evt.target.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
  }
  function enlarge(event) {
    event.target.style.transform = "scale(2)";
  }

  function renderSingleProof(proofData) { 
    if (proofData.type === "link") { 
      return <Link key={proofData.url} target='_blank' href={proofData.url}>{proofData.url}</Link>;
    }
    if (proofData.type === "image") { 
      return <Image key={proofData.url} onClick={enlarge} width="60%" src={proofData.url}/>;
    }
    if (proofData.type === "text") { 
      return <p>{proofData.data}</p>;
    }
    return '';
  }

  function renderAllProofs() { 
    const proofs = content;
    if (!proofs.length) { 
      return <p>No proofs yet</p>
    }
    return proofs.map((el) => renderSingleProof(el));
  }
  function getClasses() {
    if (!content.length) { 
      return 'accordion empty';
    }
    return 'accordion'
  }
  return (
    <>
      <button key={name} class={getClasses()} onClick={onClick}>{name}</button>
      <div class="panel">
        {renderAllProofs()}
      </div>
    </>
  );
}